import "./InputRadio.scss";
import PropTypes from "prop-types";
import _ from "lodash";

const InputRadio = ({
  option,
  getSelectedValue,
  name,
  isChecked,
  readOnly,
}) => {
  const formattedId = _.chain(name)
    .lowerCase()
    .split(" ")
    .join("_")
    .concat(option.rval)
    .join("_")
    .value();
  return (
    <div
      className="input-radio"
      style={{ marginTop: "-13px", textAlign: "center" }}
    >
      <p style={{ border: "unset" }} key={option?.val}>
        <input
          type="radio"
          id={formattedId}
          value={option.val}
          name={_.chain(name).lowerCase().split(" ").join("_").value()}
          onChange={(e) => {
            if (!readOnly) {
              getSelectedValue({
                id: _.chain(name).lowerCase().split(" ").join("_").value(),
                value: e?.target?.value,
              });
            }
          }}
          checked={isChecked}
        />
        <label
          for={formattedId}
          style={{ cursor: readOnly ? "unset" : "pointer" }}
        />
      </p>
    </div>
  );
};

InputRadio.propTypes = {
  getSelectedValue: PropTypes.func.isRequired,
  option: PropTypes.object,
  defaultValue: PropTypes.string,
  name: PropTypes.string,
};
InputRadio.defaultProps = {
  defaultValue: null,
  option: {},
  name: "",
};
export default InputRadio;
